/* @flow */

import React from 'react';
import FaRotateLeft from 'react-icons/lib/fa/rotate-left';
import { Button } from 'reactstrap';

import { createHTMLMarkup } from '../../utils';

// import cx from 'classnames';
// import classes from './RevertInput.scss';

type PropsType = {
  className: string,
  enable: boolean,
  onClick: Function,
  value: string | number,
};

export class RevertInput extends React.PureComponent<PropsType, *> {
  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const string = createHTMLMarkup(`Recommended: [<span>${this.props.value}</span>]`);

    return (
      <div className={this.props.className}>
        <Button
          color="link"
          size="sm"
          disabled={!this.props.enable}
          onClick={this.props.onClick}
        >
          {string} {' '}<FaRotateLeft />
        </Button>
      </div>
    );
  }
}

export default RevertInput;



// WEBPACK FOOTER //
// ./src/components/RevertInput/RevertInput.js